import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useMutation } from 'react-query';

function useManagePlayable({ podcastId, episodeId, playableId }) {
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  const isEditMode = playableId !== 'add';

  function sendPlayableData(data) {
    const url = isEditMode
      ? `/v1/admin/podcast/${podcastId}/episode/${episodeId}/playable/${playableId}`
      : `/v1/admin/podcast/${podcastId}/episode/${episodeId}/playable`;

    const method = isEditMode ? 'put' : 'post';

    return privateFetch[method](url, data).then((res) => res.data);
  }

  return useMutation(sendPlayableData);
}

export default useManagePlayable;
